import { BookOpen, Calculator, ChartColumn, Database, FileText, Package, Plug, Rocket, Settings } from 'lucide-react';

// Icons by category slug, the docs repo's folder names. A category added there
// later falls back to a book until it gets one here.
export const HELP_CATEGORY_ICONS = {
  'getting-started': Rocket,
  estimates: Calculator,
  'estimate-reports': FileText,
  database: Database,
  'comparison-reports': ChartColumn,
  'bid-management': Package,
  'account-settings': Settings,
  integrations: Plug
};

export const DEFAULT_HELP_CATEGORY_ICON = BookOpen;

// Article titles a landing page card lists before "See All".
export const HELP_CATEGORY_PREVIEW_COUNT = 5;

// Wait after the last keystroke before searching.
export const HELP_SEARCH_DEBOUNCE_MS = 250;

// What the assistant's endpoint accepts in one request: the API answers 400
// past either, so the conversation sent is trimmed to fit.
export const HELP_ASSISTANT_MAX_MESSAGES = 12;
export const HELP_ASSISTANT_MAX_MESSAGE_LENGTH = 4000;

// Offered in the assistant before the first question, to show what it is for.
export const HELP_ASSISTANT_SUGGESTED_QUESTIONS = ['How do I create a new estimate?', 'How do I add comps after an estimate is created?', 'How do I level a bid quote with AI?'];
